import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=fa9d6b56&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=fa9d6b56&prod&lang=stylus&scoped=true"
import style1 from "./Index.vue?vue&type=style&index=1&id=fa9d6b56&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9d6b56",
  null
  
)

export default component.exports